import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const [synchronized, setSynchronized] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {

    axios.request("/common/time",{
      method:"GET",
      headers:{
        'Content-Type': 'application/json'
      }
    }).then(async (res)=>{

      setCurrent(new Date(res.data.time).toLocaleString());

      if(Math.abs(res.data.time - new Date().getTime()) < 2 * 60 * 1000 ){
        setSynchronized(true);
      }else{
        setSynchronized(false);
      }

    })

    return ()=>{ }

  }, []);

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  const not_supported = <Fragment>
        <Segment placeholder>
          <Header icon>
            <Icon name='cloud upload' />
            <p>Pro/Team/Enterprise Membership Required</p>
          </Header>
          <Link to="/console/shop">
            <Button primary>Upgrade</Button>
          </Link>
        </Segment>
  </Fragment>

  var subscribe_endpoint = "update.glados-config.com";
  //subscribe_endpoint = "update.glados-config.net";
  //subscribe_endpoint = "update.glados-config.org";

  const profile  = `https://${subscribe_endpoint}/surge/${user_id}/${hashed}/glados.network.conf`
  const servers  = `https://${subscribe_endpoint}/surge/${user_id}/${hashed}/glados.servers.conf`

  const [url,setURL] = useState(false);

  if(url){
    return <Redirect to={url}/>
  }


  var panes = [{
      menuItem:<Menu.Item key='mac'>Surge for Mac</Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          <p>1. Click Settings - Profile - Install from URL from Surge Mac</p>
          <p>2. Enter <Label>{profile}</Label>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={`${profile}`}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          </p>
          <p>3. Select This Configure File</p>
          <p>4. Start</p>

          <p>The rules are designed with simplicity in mind.</p>
          <p>Note 1: In case you need server group settings, please use this {servers}</p>
          <p>Note 2: All non-domestic requests will be sent through the Proxy, Auto is automatic speed-testing group, and GLaDOS is manual group.</p>
          <p>Note 3: First round benchmark include DNS resolving time，so the second round is more acurate.</p>

        </Tab.Pane>)
      }
    },{
      menuItem:<Menu.Item key='ios'>Surge for iOS</Menu.Item>,
      render: () => {
        return (<Tab.Pane style={{padding:"10px",margin:"0px"}}>

          <p>1. Click top left icon and select "Download Profile from URL"</p>
          <p>2. Enter <Label>{profile} </Label>
            <Clipboard
              style={{"borderRadius": "5px", "padding": "4px"}}
              onSuccess={()=>{ setClipboard(true) }}
              data-clipboard-text={`${profile}`}>
              { clipboard ? "copied" : "copy to clipboard" }
            </Clipboard>
          </p>
          <p>3. Ensure Outbound Mode is on "Rule Based Proxy" </p>

          <p>The rules are designed with simplicity in mind.</p>
          <p>Note 1: In case you need server group settings, please use this {servers}</p>
          <p>Note 2: All non-domestic requests will be sent through the Proxy, Auto is automatic speed-testing group, and GLaDOS is manual group.</p>
          <p>Note 3: First round benchmark include DNS resolving time，so the second round is more acurate.</p>
        </Tab.Pane>)
      }
    }

  ]

  const [clipboard,setClipboard] = useState(false);

  return (
  <Fragment>

    <Header as='h2' color="blue">
      {t("settings.surge.title")}
      <Header.Subheader>
      {t("settings.surge.notes")}
      </Header.Subheader>
    </Header>
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>
            Surge
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        <Segment>
          {user_vip>30?<Tab  menu={{ color:"blue", secondary: true}} panes={panes} />:not_supported}
        </Segment>
      </Table.Body>
    </Table>

  </Fragment>
  )
}
export {Guide};
